<div>
  <app-page-breadcrumb pageTitle="Series documentales" />

  <div class="mb-4 flex justify-end rounded-2xl border border-gray-200 bg-white px-4 py-4 dark:border-gray-800 dark:bg-white/3">
    <button type="button"
      class="inline-flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white hover:bg-brand-600"
      (click)="onCreateSeries()">
      + Agregar
    </button>
    <button type="button"
      class="ml-2 inline-flex items-center gap-2 rounded-lg bg-gray-200 px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-300"
      (click)="loadSeries()" [disabled]="loadingTable">
      {{ loadingTable ? 'Actualizando…' : 'Actualizar' }}
    </button>
  </div>

  <div class="min-h-[60vh] rounded-2xl border border-gray-200 bg-white px-3 py-5 dark:border-gray-800 dark:bg-white/3 xl:px-4 xl:py-5">
    <div class="rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/5 dark:bg-white/3">

      <!-- Header / Search -->
      <div class="flex flex-col gap-2 px-5 mb-4 sm:flex-row sm:items-center sm:justify-between sm:px-6">
        <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Listado de series</h3>
        <div class="relative">
          <button class="absolute -translate-y-1/2 left-4 top-1/2" type="button">
            <svg class="fill-gray-500 dark:fill-gray-400" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path fill-rule="evenodd" clip-rule="evenodd"
                d="M3.04199 9.37381C3.04199 5.87712 5.87735 3.04218 9.37533 3.04218C12.8733 3.04218 15.7087 5.87712 15.7087 9.37381C15.7087 12.8705 12.8733 15.7055 9.37533 15.7055C5.87735 15.7055 3.04199 12.8705 3.04199 9.37381ZM9.37533 1.54218C5.04926 1.54218 1.54199 5.04835 1.54199 9.37381C1.54199 13.6993 5.04926 17.2055 9.37533 17.2055C11.2676 17.2055 13.0032 16.5346 14.3572 15.4178L17.1773 18.2381C17.4702 18.531 17.945 18.5311 18.2379 18.2382C18.5308 17.9453 18.5309 17.4704 18.238 17.1775L15.4182 14.3575C16.5367 13.0035 17.2087 11.2671 17.2087 9.37381C17.2087 5.04835 13.7014 1.54218 9.37533 1.54218Z" />
            </svg>
          </button>
          <input type="text" placeholder="Buscar..." (input)="setSearchTerm($any($event.target).value)"
            class="dark:bg-dark-900 h-10.5 w-full rounded-lg border border-gray-300 bg-transparent py-2.5 pl-10.5 pr-4 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30 xl:w-75" />
        </div>
      </div>

      <!-- Table -->
      <div class="max-w-full px-5 overflow-x-auto sm:px-6">
        <table class="w-full min-w-full">
          <thead class="border-gray-100 border-y dark:border-white/5">
            <tr>
              <th class="py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">
                <button class="inline-flex items-center gap-1 hover:text-gray-700 dark:hover:text-gray-200"
                  (click)="toggleSort('tipo')">
                  Tipo
                  <svg class="w-3.5 h-3.5" [class.text-brand-500]="sortColumn === 'tipo'" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="2">
                    @if (sortColumn === 'tipo' && sortDir === 'asc') {
                    <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7" />
                    } @else if (sortColumn === 'tipo' && sortDir === 'desc') {
                    <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                    } @else {
                    <path stroke-linecap="round" stroke-linejoin="round" d="M7 16V4m0 0L3 8m4-4l4 4M17 8v12m0 0l4-4m-4 4l-4-4" />
                    }
                  </svg>
                </button>
              </th>
              <th class="w-[14%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Serie</th>
              <th class="w-[14%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Correlativo</th>
              <th class="w-[12%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Estado</th>
              <th class="w-[12%] py-3 font-normal text-gray-500 text-start text-theme-sm dark:text-gray-400">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-white/5">
            @if (loading) {
            <tr><td class="py-4 text-center text-gray-500 text-theme-sm" colspan="5">Cargando...</td></tr>
            } @else if (currentItems.length === 0) {
            <tr><td class="py-4 text-center text-gray-500 text-theme-sm" colspan="5">No hay datos disponibles.</td></tr>
            } @else {
            @for (item of currentItems; track item.id) {
            <tr>
              <td class="py-2">
                <p class="font-medium text-gray-700 text-theme-sm dark:text-gray-400">{{ item.documentTypeSunatName }}</p>
                <p class="text-xs text-gray-400">
                  {{ item.documentTypeSunatCode }}
                  @if (item.parentDocumentTypeCode) {
                  · ref. {{ item.parentDocumentTypeCode === '01' ? 'Factura' : 'Boleta' }}
                  }
                </p>
              </td>
              <td class="py-2 font-mono font-semibold text-gray-700 text-theme-sm dark:text-gray-400">{{ item.series }}</td>
              <td class="py-2 text-gray-700 text-theme-sm dark:text-gray-400">{{ item.sequence }}</td>
              <td class="py-2">
                <app-badge size="sm" [color]="getBadgeColor(item.status)">{{ getBadgeText(item.status) }}</app-badge>
              </td>
              <td class="py-2">
                <div class="inline-flex items-center gap-1.5">
                  <button type="button"
                    class="inline-flex items-center gap-2 rounded-md bg-orange-300 px-2.5 py-2 text-sm font-medium text-white hover:bg-orange-400 disabled:opacity-40 disabled:cursor-not-allowed"
                    [disabled]="item.sequence > 0"
                    [title]="item.sequence > 0 ? 'No editable: ya tiene comprobantes emitidos' : 'Editar'"
                    (click)="onEditSeries(item)">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M20.8749 2.51272C20.1915 1.8293 19.0835 1.8293 18.4001 2.51272L13.2418 7.67095C12.879 8.03379 12.6511 8.50974 12.5959 9.0199L12.4069 10.7668C12.3824 10.9926 12.4616 11.2173 12.6222 11.3778C12.7827 11.5384 13.0074 11.6176 13.2332 11.5931L14.9801 11.4041C15.4903 11.3489 15.9662 11.121 16.3291 10.7582L21.4873 5.59994C22.1707 4.91652 22.1707 3.80848 21.4873 3.12506L20.8749 2.51272ZM18.5981 4.43601L19.564 5.40191L15.2684 9.69751C15.1474 9.81846 14.9888 9.89443 14.8187 9.91283L13.9984 10.0016L14.0872 9.18126C14.1056 9.01121 14.1815 8.85256 14.3025 8.73161L18.5981 4.43601Z"
                        fill="#323544" />
                      <path
                        d="M5.5 3.25H15.5411L14.0411 4.75H5.5C5.08579 4.75 4.75 5.08579 4.75 5.5V18.5C4.75 18.9142 5.08579 19.25 5.5 19.25H18.5C18.9142 19.25 19.25 18.9142 19.25 18.5V9.95823L20.75 8.45823V18.5C20.75 19.7426 19.7426 20.75 18.5 20.75H5.5C4.25736 20.75 3.25 19.7426 3.25 18.5V5.5C3.25 4.25736 4.25736 3.25 5.5 3.25Z"
                        fill="#323544" />
                    </svg>
                  </button>
                  @if (item.status !== 2) {
                  <button type="button"
                    class="inline-flex items-center gap-2 rounded-md px-2.5 py-2 text-sm font-medium text-white"
                    [class]="item.status === 1 ? 'bg-red-300 hover:bg-red-400' : 'bg-green-300 hover:bg-green-400'"
                    (click)="openToggleConfirm(item)">
                    @if (item.status === 1) {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M10.249 2C9.00638 2 7.99902 3.00736 7.99902 4.25V5H5.5C4.25736 5 3.25 6.00736 3.25 7.25C3.25 8.28958 3.95503 9.16449 4.91303 9.42267L5.54076 19.8848C5.61205 21.0729 6.59642 22 7.78672 22H16.2113C17.4016 22 18.386 21.0729 18.4573 19.8848L19.085 9.42267C20.043 9.16449 20.748 8.28958 20.748 7.25C20.748 6.00736 19.7407 5 18.498 5H15.999V4.25C15.999 3.00736 14.9917 2 13.749 2H10.249ZM14.499 5V4.25C14.499 3.83579 14.1632 3.5 13.749 3.5H10.249C9.83481 3.5 9.49902 3.83579 9.49902 4.25V5H14.499ZM5.5 6.5C5.08579 6.5 4.75 6.83579 4.75 7.25C4.75 7.66421 5.08579 8 5.5 8H18.498C18.9123 8 19.248 7.66421 19.248 7.25C19.248 6.83579 18.9123 6.5 18.498 6.5H5.5ZM6.42037 9.5H17.5777L16.96 19.7949C16.9362 20.191 16.6081 20.5 16.2113 20.5H7.78672C7.38995 20.5 7.06183 20.191 7.03807 19.7949L6.42037 9.5Z"
                        fill="#323544" />
                    </svg>
                    } @else {
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M20.285 6.709a1 1 0 0 1 .006 1.414l-9.2 9.3a1 1 0 0 1-1.42-.002L3.71 11.46a1 1 0 1 1 1.414-1.414l4.06 4.06 8.49-8.58a1 1 0 0 1 1.41.183Z"
                        fill="#323544" />
                    </svg>
                    }
                  </button>
                  }
                </div>
              </td>
            </tr>
            }
            }
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="px-6 py-4 border-t border-gray-200 dark:border-white/5">
        <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-500 dark:text-gray-400">Mostrar</span>
            <select class="h-9 rounded-lg border border-gray-300 bg-white px-2 text-sm text-gray-700 focus:border-brand-300 focus:outline-none dark:border-gray-700 dark:bg-gray-900 dark:text-gray-300"
              (change)="onPageSizeChange(+$any($event.target).value)">
              @for (opt of pageSizeOptions; track opt) {
              <option [value]="opt" [selected]="opt === itemsPerPage">{{ opt }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400">registros</span>
          </div>
          <div class="flex items-center gap-2">
            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage - 1)" [disabled]="currentPage === 1">
              <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M2.58301 9.99868C2.58272 10.1909 2.65588 10.3833 2.80249 10.53L7.79915 15.5301C8.09194 15.8231 8.56682 15.8233 8.85981 15.5305C9.15281 15.2377 9.15297 14.7629 8.86018 14.4699L5.14009 10.7472L16.6675 10.7472C17.0817 10.7472 17.4175 10.4114 17.4175 9.99715C17.4175 9.58294 17.0817 9.24715 16.6675 9.24715L5.14554 9.24715L8.86017 5.53016C9.15297 5.23717 9.15282 4.7623 8.85983 4.4695C8.56684 4.1767 8.09197 4.17685 7.79917 4.46984L2.84167 9.43049C2.68321 9.568 2.58301 9.77087 2.58301 9.99715Z" />
              </svg>
              <span class="hidden sm:inline">Anterior</span>
            </app-button>
            <span class="text-sm text-gray-700 dark:text-gray-400">{{ currentPage }} / {{ totalPages }}</span>
            <app-button size="sm" variant="outline" (btnClick)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages">
              <span class="hidden sm:inline">Siguiente</span>
              <svg class="fill-current" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M17.4175 9.9986C17.4178 10.1909 17.3446 10.3832 17.198 10.53L12.2013 15.5301C11.9085 15.8231 11.4337 15.8233 11.1407 15.5305C10.8477 15.2377 10.8475 14.7629 11.1403 14.4699L14.8604 10.7472L3.33301 10.7472C2.91879 10.7472 2.58301 10.4114 2.58301 9.99715C2.58301 9.58294 2.91879 9.24715 3.33301 9.24715L14.8549 9.24715L11.1403 5.53016C10.8475 5.23717 10.8477 4.7623 11.1407 4.4695C11.4336 4.1767 11.9085 4.17685 12.2013 4.46984L17.1588 9.43049C17.3173 9.568 17.4175 9.77087 17.4175 9.99715Z" />
              </svg>
            </app-button>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- MODAL: Formulario -->
<app-modal [isOpen]="showForm" [className]="'max-w-lg p-6 sm:p-8'" (close)="onCloseForm()">
  <div class="mb-5">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">
      {{ isEditMode ? 'Editar serie' : 'Nueva serie' }}
    </h3>
    <p class="text-sm text-gray-500 dark:text-gray-400">
      {{ isEditMode ? 'Solo editable si aún no tiene comprobantes emitidos.' : 'Máximo 2 series activas por tipo de documento.' }}
    </p>
  </div>

  <form (ngSubmit)="onSubmit()" class="space-y-5">

    @if (!isEditMode) {
    <div>
      <app-label>Tipo de documento <span class="text-error-500">*</span></app-label>
      <app-select placeholder="Seleccionar tipo" [options]="documentTypeOptions" [(value)]="formDocTypeCode"></app-select>
      @if (submitted && !formDocTypeCode) {
      <p class="mt-1 text-sm text-error-500">Tipo de documento requerido</p>
      }
    </div>
    @if (requiresParentDocType) {
    <div>
      <app-label>Documento de referencia <span class="text-error-500">*</span></app-label>
      <app-select placeholder="¿Referencia Factura o Boleta?" [options]="parentDocTypeOptions" [(value)]="formParentDocTypeCode"></app-select>
      <p class="mt-1 text-xs text-gray-400 dark:text-gray-500">Las NC/ND deben indicar si corrigen una Factura o una Boleta.</p>
      @if (submitted && requiresParentDocType && !formParentDocTypeCode) {
      <p class="mt-1 text-sm text-error-500">Debes indicar si la serie es para Factura o Boleta de Venta</p>
      }
    </div>
    }
    } @else {
    <div>
      <app-label>Tipo de documento</app-label>
      <app-input-field [value]="editingDocTypeName" [disabled]="true" />
    </div>
    @if (formParentDocTypeCode) {
    <div>
      <app-label>Documento de referencia</app-label>
      <app-input-field [value]="formParentDocTypeCode === '01' ? '01 - Factura' : '03 - Boleta de Venta'" [disabled]="true" />
    </div>
    }
    }

    <div>
      <app-label>Serie <span class="text-error-500">*</span></app-label>
      @if (isEditMode && editingSequence > 0) {
      <app-input-field [value]="formSeriesValue" [disabled]="true" />
      <p class="mt-1 text-xs text-warning-500">No modificable: ya tiene {{ editingSequence }} comprobante(s) emitido(s).</p>
      } @else {
      <app-input-field placeholder="Ej: F001" [(value)]="formSeriesValue" maxlength="4" />
      @if (submitted && !formSeriesValue.trim()) {
      <p class="mt-1 text-sm text-error-500">Serie requerida</p>
      }
      }
    </div>

    <div class="flex items-center justify-end gap-3 pt-2 border-t border-gray-100 dark:border-gray-800">
      <button type="button" (click)="onCloseForm()"
        class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Cancelar
      </button>
      <button type="submit" [disabled]="isSubmitting || (isEditMode && editingSequence > 0)"
        class="px-4 py-2 text-sm font-medium text-white rounded-lg bg-brand-500 hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
        {{ isSubmitting ? 'Guardando…' : (isEditMode ? 'Guardar cambios' : 'Registrar') }}
      </button>
    </div>

  </form>
</app-modal>

<!-- MODAL: Confirmar toggle -->
<app-modal [isOpen]="showConfirmToggle" [className]="'max-w-md p-6 sm:p-7'" (close)="closeToggleConfirm()">
  <div class="mb-3">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-white/90">Confirmar acción</h3>
    <p class="text-sm text-gray-500 dark:text-gray-400">{{ toggleConfirmText }}</p>
  </div>
  <div class="flex items-center justify-end gap-3 pt-4">
    <button type="button" (click)="closeToggleConfirm()"
      class="px-4 py-2 text-sm font-medium rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
      Cancelar
    </button>
    <button type="button" (click)="confirmToggleStatus()" [disabled]="isToggling"
      class="px-4 py-2 text-sm font-medium text-white rounded-lg"
      [class]="toggleTarget?.status === 1 ? 'bg-red-500 hover:bg-red-600' : 'bg-green-500 hover:bg-green-600'">
      {{ isToggling ? 'Procesando...' : toggleActionLabel }}
    </button>
  </div>
</app-modal>
